export { PackagingDoubleBanner } from './PackagingDoubleBanner';
